<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/shadcn-lib/utils";
import { inject, computed, provide } from "vue";

const props = defineProps<{
  value: string;
  class?: HTMLAttributes["class"];
  disabled?: boolean;
}>();

interface AccordionContext {
  type: "single" | "multiple";
  value: import("vue").Ref<string[]>;
  onValueChange: (value: string[]) => void;
  collapsible?: boolean;
}

const context = inject<AccordionContext>("accordion-context");

const open = computed(() => {
  if (!context) return false;
  return context.value.value.includes(props.value);
});

provide("accordion-item-context", {
  value: props.value,
  open,
  disabled: props.disabled,
});
</script>

<template>
  <div data-slot="accordion-item" :class="cn('border-b', props.class)">
    <slot />
  </div>
</template>
